import React, { useEffect, useContext, useState, FC } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga';
import styles from './App.module.scss';
//Components
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { EuPortability } from './components/UI/Modals/EuPortability';

import { AuthContext } from './context/auth';

import { usePrefetchQuery } from './pages/movies/movieDetails/query';
import { useAppLogout } from './core/api/components/AppLogout/useAppLogout';
import { StbPromotionsModal } from './components/UI/Modals/StbPromotionsModal';
import { RoutesList } from './routes';
import { CookieModal } from './components/Cookie';

const gaCode = process.env.REACT_APP_GOOGLE_ANALYTICS;

// Initalizing google analytics

ReactGA.initialize(gaCode as string);

const App: FC = () => {
  const authContext = useContext(AuthContext);
  const {
    isAuthenticated,
    loading,
    firstLogin,
    euPortabilityStatusPopup,
    euPortabilityStatusPopupText,
    loadUser,
    user,
  } =
    authContext;
  const [showModal, setShowModal] = useState<boolean>(false);
  const userHasPromotions = user.stb_promotions?.length && user.stb_promotions?.length > 0 ? true : false;
  const [userOnboardingModal, setUserOnboardingModal] = useState<boolean>(false);
  const { pathname } = useLocation();
  usePrefetchQuery();
  const withContrast = true;

  useEffect(() => {
    ReactGA.pageview(pathname);
  }, [pathname]);

  console.log(isAuthenticated,loading, 'App state');

  useEffect(() => {
    document.body.classList.toggle('contrast', withContrast);
  }, [withContrast]);

  useEffect(() => {
    if (isAuthenticated && !loading && firstLogin) {
      if (euPortabilityStatusPopup) {
        setShowModal(true);
      }
      if (userHasPromotions) {
        setUserOnboardingModal(true);
      }
    }
  }, [euPortabilityStatusPopup, firstLogin, isAuthenticated, loading, userHasPromotions]);

  useEffect(() => {
    if( isAuthenticated && !loading) {
      loadUser();
    }
  }, [isAuthenticated, loading, loadUser]);

  //App logout timer and event listener
  useAppLogout();

    return (
      <>
        <div className={styles.container}>
          <Header />
          <div className={styles.content}>
            <EuPortability
              text={euPortabilityStatusPopupText}
              show={showModal}
              onHide={() => {
                setShowModal(false);
              }}
              centered={true}
            />

            {userHasPromotions && (
              <StbPromotionsModal
                show={userOnboardingModal}
                onHide={() => {
                  setUserOnboardingModal(false);
                }}
              />
            )}

            <RoutesList />
          </div>
          <div className={styles.footer}>
            <Footer />
          </div>
        </div>
        <CookieModal />
      </>
    );
};

export default App;
